import { db } from "@/api/firebase";
import { Game } from "@/models/Game";
import { GameWarning } from "@/models/Errors/GameWarning";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { isEmpty } from "lodash";
import Warnings from "./Warnings";

export default class WarningsGame {
  mapPoi: ManhuntMapPoi[];
  gamesUid: string;
  game = {} as Game;
  warningObject = {} as GameWarning;
  constructor(game: Game, gamesUid: string, mapPoi: ManhuntMapPoi[]) {
    this.game = game;
    this.mapPoi = mapPoi;
    this.gamesUid = gamesUid;
  }

  checkWarningsErrors(): void {
    try {
      this.checkAllMapPoiWarning();
      this.countWarnIssues();
      this.countPlayerRegister();
      if (!isEmpty(this.warningObject)) {
        db.ref("games/" + this.gamesUid + "/issues/warn/").set(
          this.warningObject
        );
      } else {
        db.ref("games/" + this.gamesUid + "/issues/warn/").remove();
      }
    } catch (error) {
      console.log(error);
    }
  }

  private countPlayerRegister(): void {
    if (this.game.team_count === undefined || this.game.team_count > 0) {
      this.warningObject.players_registered = {
        active: true,
        txt: {
          en: this.game.team_count + " number of teams are registered/playing",
        },
      };
    }
  }

  private countWarnIssues(): void {
    let count = 0;
    this.mapPoi.forEach((x: ManhuntMapPoi) => {
      if (x.issues?.warn !== undefined) {
        count++;
      }
    });
    if (count > 0) {
      this.warningObject.warning_count = {
        active: true,
        txt: { en: "POI Warning: " + count + " POIs with warning" },
      };
    }
  }
  private checkAllMapPoiWarning(): void {
    try {
      this.mapPoi.forEach((x: ManhuntMapPoi) => {
        const warningObject = new Warnings(
          x,
          this.gamesUid
        ).checkMapPoiWarningErrors();
        if (!isEmpty(warningObject)) {
          x.issues = { warn: warningObject };
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}
